<div class="scenario-benefits-tree-actions">
    <form-button
        v-if="editBenefit"
        type="a"
        class="btn btn-sm btn-blue text-center m-1"
        @click="call('editBenefit')"
    >
        <template v-slot:center>
            <span class="icon edit green m-auto"></span>
        </template>
    </form-button>
</div>
